export function mileageNoDecimals(mileage: number) {
  return mileage.toLocaleString('en', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}
